import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";

import { getLatestStories } from "actions/latestStories";
import MiniStoryCard from "components/Library/MiniStoryCard";
import Spinner from "components/Library/Spinner";
import Ad from "components/Library/Ad";
import LazyLoad from "components/Library/Lazyload";

import styles from "./NewNavigation.css";

class LatestStories extends Component {
  componentDidMount() {
    if (!this.props.latestStories.results.length) {
      this.props.getLatestStories();
    }
  }

  renderPromo() {
    return (
      <div className={styles.promo}>
        <LazyLoad>
          <Ad
            adUnit="sidebar"
            slotSize={[300, 275]}
            renderWhenViewable={false}
          />
        </LazyLoad>
      </div>
    );
  }

  render() {
    const { className, latestStories, latestStoriesRef } = this.props;
    if (latestStories.results.length === 0) {
      if (latestStories.isLoading) {
        return <Spinner />;
      }
      return null;
    }
    const latestSorted = [...latestStories.results].sort((a, b) =>
      new Date(a.published_date).getTime() >
      new Date(b.published_date).getTime()
        ? -1
        : 1
    );

    return (
      <div className={className}>
        <h2 className={classNames(styles.heading, styles.hiddenLarge)}>
          Latest Stories
        </h2>
        <div className={styles.root}>
          <h2 className={classNames(styles.heading, styles.hiddenSmall)}>
            Latest Stories
          </h2>
          {latestSorted.map((latest, i) => (
            <div key={latest.id}>
              <MiniStoryCard
                storyCardRef={
                  i === latestStories.results.length - 1
                    ? latestStoriesRef
                    : undefined
                }
                className={
                  i === latestStories.results.length - 1 &&
                  "finalLatestStoriesItem"
                }
                latest={latest}
              />
              {i === 4 && this.renderPromo()}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

LatestStories.propTypes = {
  getLatestStories: PropTypes.func,
  latestStories: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    isLoading: PropTypes.bool,
  }),
  className: PropTypes.string,
  latestStoriesRef: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    latestStories: state.latestStories,
  };
};

export default connect(
  mapStateToProps,
  { getLatestStories }
)(LatestStories);
